import React from 'react';
import HtmlLegalDocumentPage from '../components/HtmlLegalDocumentPage';

export default function TermsAndConditions() {
  return <HtmlLegalDocumentPage documentPath="/legal/terms-and-conditions.html" />;
}
